module.exports = __webpack_public_path__ + "static/media/youtube.bbd2d4eb.svg";